module.exports = __webpack_public_path__ + "img/24-june-2025.9aae6129.jpeg";